<template>
    <div id="questionnaire">
        <h3 class="question1">{{datas.titre}}</h3>
        <div class="w-2/4 flex flex-col items-center gap-4 ml-auto mr-auto mt-5 mb-5">
            <input v-model="inputTextValue" class="border-black border-solid border-t-0 border-r-0 border-l-0 border-b-2 text-3xl text-center focus:outline-none" id="caseInput" type="textarea"  name="name" placeholder="123456789" 
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" minlength="9" maxlength="9" required>
            <p class="text-gray-600 text-xs italic">{{ $t("enterRef9numbers") }}</p>
            <button id ="submitBtn" class="bg-secondary text-white px-8 py-1 transition duration-300 delay-250 hover:text-primary delay-0 uppercase mb-2 w-40 center" :disabled="isDisabled()" @click="setRefBrouette(), $store.commit('setCurrentStep', datas);">{{ $t("validate") }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            datas: Object
        },
        data(){
            return {
                inputTextValue : null
            }
        },

        mounted(){
            // Get the input field
            let input = document.getElementById("caseInput");
            input.addEventListener('focus', function(){
                this.ariaPlaceholder = ''
            })
            // Execute a function when the user releases a key on the keyboard
            input.addEventListener("keyup", function(event) {
            // Number 13 is the "Enter" key on the keyboard
            if (event.keyCode === 13) {
                // Cancel the default action, if needed
                event.preventDefault();
                // Trigger the button element with a click
                document.getElementById("submitBtn").click();
            }
            }); 
        },
        methods: {
            setRefBrouette: function() {
                this.$store.state.refBrouetteConnue = this.inputTextValue;
            },
            isDisabled: function() {
                if(this.inputTextValue){
                    if(this.inputTextValue.length === 9) {
                        return false;
                    }
                    if(this.inputTextValue.length !== 9) {
                        return true;
                    }
                }
                else {
                    return true;
                }
            },
        }
    }
</script>